import React from 'react';
import Icon from 'src/components/Icon/Icon';
import { observer } from 'src/utils/mobx-react';
import { useAppStateContext } from 'src/AppState/AppState';
import EMPTY_HR_SILK from 'src/components/CustomersBar/EventsTab/RacingTab/assets/empty-hr-silk.png';
import { LazyImage } from 'src/components/Image/LazyImage';
import { MARKET_TYPE } from 'src_common/common/websocket2/models/EventModel';
import Trap from 'src/components/Trap/Trap';
import { TypeId } from 'src_common/common/websocket2/type';
import {
    QuickPickNameList,
    QuickPickSelectionDetails,
    QuickPickTitle,
    TrapWrapper,
} from 'src/components/CustomersBar/EventsTab/RacingTab/QuickPick/QuickPickName.style';
import {
    QuickPickViewState,
    sortSelections,
} from 'src/components/CustomersBar/EventsTab/RacingTab/QuickPickView/QuickPickView.state';

interface QuickPickNamePropsType {
    eventId: number;
    marketId: TypeId.MarketId | null;
    quickPickState: QuickPickViewState;
}

export const QuickPickName = observer('QuickPickName', (props: QuickPickNamePropsType) => {
    const appState = useAppStateContext();
    const eventId = props.quickPickState.hoveredEventId ?? props.quickPickState.filteredEventsId[0];
    if (eventId === undefined || props.marketId === null) {
        console.log('QuickPickName - eventId', eventId);
        console.log('QuickPickName - props.marketId', props.marketId);

        return null;
    }
    const race = appState.sdkStaff.models.getEvent(eventId);
    const market = appState.sdkStaff.models.getMarket(props.marketId);
    //TODO: nie podoba mi się to, poprawić proszę z następnym marketem!
    const marketsWithoutNameComponent =
        market === null ||
        market.newTemplateId.includes(MARKET_TYPE.MATCH_BET) ||
        market.newTemplateId.includes(MARKET_TYPE.SUB_RACE) ||
        market.newTemplateId.includes(MARKET_TYPE.WITHOUT);

    if (race === null || market === null || marketsWithoutNameComponent) {
        return null;
    }

    const isGreyhoundracing = race.sport === 'greyhoundracing';
    const getSortIndicator = (): JSX.Element => {
        if (props.quickPickState.sort === 'asc') {
            return <Icon name='up' />;
        } else {
            return <Icon name='down' />;
        }
    };

    const renderMetaData = (): string | null => {
        if (market.eachWay !== undefined && market.eachWay.offered) {
            const ew = market.eachWay;
            const terms = ew.terms[0];
            if (terms === undefined) {
                return '-- -- Places';
            } else {
                return `${terms.reduction} ${terms.places} Places`;
            }
        }
        return null;
    };

    return (
        <QuickPickNameList>
            <QuickPickTitle onClick={props.quickPickState.onSetSort}>
                <span className='quick-pick__name__runner'>
                    <p>Runner {getSortIndicator()}</p>
                    <small>{renderMetaData()}</small>
                </span>
            </QuickPickTitle>
            {sortSelections(market.selections, props.quickPickState.sort).map((selection) => {
                const isUnnamedFavourite = selection.templateId === 'unnamed-favourite';
                const nonRunner =
                    selection.computedMetaData?.status === 'Non-Runner' || selection.resultType === 'void';
                const jockey = selection.metaDataJockey;
                const trainer = selection.metaDataTrainer;
                const number = selection.metaDataNumber;
                const drawn = selection.metaDataDrawn;
                const courseType = race.feedCourseType;
                const silkUrl = selection.metaDataSilkUrl;

                // if (isGreyhoundracing) {
                //     silkBlock = <Trap className='quick-pick-trap' number={number !== null  && number !== undefined ? +number : 0}/>;
                // }

                return (
                    <QuickPickSelectionDetails
                        key={selection.id}
                        nonRunner={nonRunner}
                        hovered={selection.id === props.quickPickState.hoveredSelectionId}
                    >
                        {isUnnamedFavourite || isGreyhoundracing ? null : (
                            <span className='quick-pick__name__place'>
                                {number === null ? null : number}
                                <br />
                                {drawn !== null && drawn !== undefined && courseType === 'Flat' ? `(${drawn})` : null}
                            </span>
                        )}

                        {isGreyhoundracing ? (
                            <TrapWrapper>
                                <Trap
                                    className='quick-pick-trap'
                                    number={number !== null && number !== undefined ? parseInt(number, 10) : 0}
                                />
                            </TrapWrapper>
                        ) : isUnnamedFavourite ? null : (
                            <span className='quick-pick__name__silk'>
                                <LazyImage
                                    className='race-summary__silk'
                                    src={silkUrl}
                                    placeholder={EMPTY_HR_SILK}
                                    alt={selection.metaDataSilk}
                                />
                            </span>
                        )}
                        <span className='quick-pick__name__runner'>
                            {selection.name === '' ? 'n/a' : selection.name}
                            {isUnnamedFavourite || isGreyhoundracing ? null : (
                                <i>
                                    {jockey === null ||
                                    jockey === undefined ||
                                    trainer === null ||
                                    trainer === undefined
                                        ? null
                                        : `${jockey} / ${trainer}`}
                                </i>
                            )}
                        </span>
                    </QuickPickSelectionDetails>
                );
            })}
        </QuickPickNameList>
    );
});
